import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { SHOWCASE_IMAGES, TRUST_POINTS } from "../mock";

const TrustAndCTA = () => {
  return (
    <>
      <section className="relative py-24 md:py-32 bg-[#efe6d4]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-14 items-center">
            <div className="relative rounded-3xl overflow-hidden aspect-[5/4] shadow-lg">
              <img src={SHOWCASE_IMAGES.trust} alt="Trust & support" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/30 to-transparent" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-emerald-900/70 font-semibold mb-4">Trust and support</div>
              <h2 className="font-display text-4xl md:text-5xl font-semibold text-emerald-950 leading-[1.05]">
                Clear policies, reachable support, <span className="italic text-emerald-700">calm control.</span>
              </h2>
              <ul className="mt-8 space-y-4">
                {TRUST_POINTS.map((p, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="mt-1 w-2 h-2 rounded-full bg-emerald-700 shrink-0" />
                    <span className="text-emerald-950/80 leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-24 md:py-28 bg-[#f6f1e7]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-display text-4xl md:text-6xl font-semibold text-emerald-950 leading-[1.02]">
            Ready to plan the trip <span className="italic text-emerald-700">without losing the group?</span>
          </h2>
          <p className="mt-5 text-emerald-950/70 text-lg max-w-xl mx-auto">
            Join thousands of travellers who swapped chaos for a plan everyone can actually follow.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Button asChild size="lg" className="rounded-full h-12 px-7 bg-emerald-900 hover:bg-emerald-800 text-white">
              <a href="#get-app" className="inline-flex items-center gap-2">Create account <ArrowRight className="w-4 h-4" /></a>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-full h-12 px-7 border-emerald-900/20 text-emerald-950 hover:bg-emerald-50">
              <a href="#contact">Talk to us</a>
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrustAndCTA;
